export var actionKey = '@@MODERATION';
export var reduxKey = '@@MODERATION';
//# sourceMappingURL=constants.js.map